import { Controller } from 'stimulus'
import { clearCsvError } from '../../src/client_side_validations'

export default class extends Controller {
  static targets = ['startDate', 'endDate', 'neverExpire', 'datesFields']

  connect() {
    // Flatpickr (child) connects after this controller; defer so altInput exists
    requestAnimationFrame(() => {
      this.toggleDates()
      this.syncEndMinDate()
    })
  }

  toggleDates() {
    const disabled = this.neverExpireTarget.checked

    this.setDisabled(this.startDateTarget, disabled)
    this.setDisabled(this.endDateTarget, disabled)

    if (disabled) {
      clearCsvError(this.startDateTarget)
      clearCsvError(this.endDateTarget)
    }

    if (this.hasDatesFieldsTarget) {
      this.datesFieldsTarget.classList.toggle('d-none', disabled)
    }

    if (!disabled) this.syncEndMinDate()
  }

  startDateChanged() {
    this.syncEndMinDate()
  }

  // End date must be on or after the selected start date.
  syncEndMinDate() {
    const startFp = this.flatpickrFor(this.startDateTarget)
    const endFp = this.flatpickrFor(this.endDateTarget)
    if (!startFp || !endFp) return

    const startDate = startFp.selectedDates[0]
    if (!startDate) return

    endFp.set('minDate', startDate)

    const endDate = endFp.selectedDates[0]
    if (endDate && endDate < startDate) endFp.setDate(startDate)
  }

  setDisabled(input, disabled) {
    input.disabled = disabled

    const flatpickrInstance = this.flatpickrFor(input)
    if (flatpickrInstance && flatpickrInstance.altInput) {
      flatpickrInstance.altInput.disabled = disabled
    }
  }

  flatpickrFor(input) {
    return input && input._flatpickr
  }
}
